module.exports = __webpack_public_path__ + "static/img/blog_good_7.9669e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_7.png
// module id = 7VaQ
// module chunks = 8